import { Box } from '@mui/material';
import { SongData } from 'services/store/distribution/types';
import { SongMetadata, SongRow } from './components';

type PropsType = {
  releaseId: string;
  song: SongData;
};

const TracklistItem = ({ releaseId, song }: PropsType) => (
  <Box>
    <SongRow song={song} />
    <SongMetadata releaseId={releaseId} song={song} />
  </Box>
);

export default TracklistItem;
